var map = {
	"./0.png": "bqNv",
	"./1.png": "HAQT",
	"./2.png": "JgXH",
	"./3.png": "LZxp",
	"./4.png": "Ebqc",
	"./5.png": "i12j",
	"./6.png": "AscF",
	"./7.png": "OyQx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f1Y";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rarity ^\.\/.*\.png$
// module id = 1f1Y
// module chunks = 0